import { normalizePermissionList } from './permissionRegistry';

/** Ключи, под которыми бэкенд может положить права в payload токена. */
const CLAIM_KEYS = ['permissions', 'perms', 'scopes'];

function decodeTokenPayload(token: string): Record<string, unknown> | undefined {
  const payload = token.split('.')[1];
  if (!payload) return undefined;
  try {
    const base64 = payload.replace(/-/g, '+').replace(/_/g, '/');
    const padded = base64 + '='.repeat((4 - (base64.length % 4)) % 4);
    const binary = atob(padded);
    const json = decodeURIComponent(
      Array.from(binary)
        .map((char) => `%${char.charCodeAt(0).toString(16).padStart(2, '0')}`)
        .join(''),
    );
    const parsed: unknown = JSON.parse(json);
    return parsed && typeof parsed === 'object' ? (parsed as Record<string, unknown>) : undefined;
  } catch {
    return undefined;
  }
}

/**
 * Права позиции лежат в payload JWT, который выдаёт switch-context.
 * Пока бэкенд их не отдаёт, вернётся пустой список — это штатно и означает
 * «про права ничего не известно».
 */
export function readPermissionsFromToken(token?: string | null): string[] {
  if (!token) return [];
  const payload = decodeTokenPayload(token);
  if (!payload) return [];
  for (const key of CLAIM_KEYS) {
    const permissions = normalizePermissionList(payload[key]);
    if (permissions.length) return permissions;
  }
  return [];
}
